// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Responsive container */
.AudioSeries_container__pkWFU {
  color: white;
  width: 100%;
  max-width: 95%;
  margin: 0 auto;
}

/* Responsive header section */
.AudioSeries_header__ExAa7 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  max-width: 100%;
  margin: 0 auto;
  flex-wrap: wrap;
}

.AudioSeries_title__uHQLU {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}

.AudioSeries_categories__Q3Iln {
  display: flex;
  gap: 15px;
  margin: 0 20px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 5px;
}

.AudioSeries_swiperCard__87HuK {
  max-width: 100%;
  margin: 0 auto;
}

.AudioSeries_categoryButton__g8HSX {
  padding: 5px 15px;
  border: none;
  background: transparent;
  color: white;
  cursor: pointer;
  border-radius: 20px;
  transition: all 0.3s ease;
  font-weight: 600;
}

.AudioSeries_categoryButton__g8HSX.AudioSeries_active__AEBz3 {
  background: #ff0000;
}

.AudioSeries_navigationButtons__XgOPL {
  display: flex;
  gap: 10px;
}

.AudioSeries_navButton__ae\\+KJ {
  background: transparent;
  border: 1px solid #ffffff40;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
}

.AudioSeries_navButton__ae\\+KJ:hover {
  background: #ffffff10;
}

.AudioSeries_cardContainer__k032t {
  position: relative;
  cursor: pointer;
}

.AudioSeries_card__wX9fa {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
}

.AudioSeries_card__wX9fa img {
  width: 100%;
  height: 250px;
  display: block;
  object-fit: cover;
}

.AudioSeries_cardContent__pFIup {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
}

.AudioSeries_cardTitle__dagGk {
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 1rem;
}

.AudioSeries_creatorName__6K57N {
  font-size: 0.9rem;
  margin: 4px 0;
}

.AudioSeries_episodeCount__80GE\\+ {
  font-size: 0.8rem;
  opacity: 0.9;
  margin: 5px 0;
}

.AudioSeries_listenButton__FoiyR {
  background: #ff0000;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 10px;
  font-size: 14px;
}

.AudioSeries_noContentMessage__3Ftgh {
  color: #ffffff80;
  text-align: center;
  padding: 30px 0;
}

.AudioSeries_loadingContainer__RupVx {
  color: #ffffff80;
  text-align: center;
  padding: 30px 0;
}

/* Mobile specific styles */
@media (max-width: 768px) {
  .AudioSeries_header__ExAa7 {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .AudioSeries_title__uHQLU {
    margin-bottom: 15px;
    width: 100%;
    font-size: 18px;
  }
  
  .AudioSeries_categories__Q3Iln {
    margin: 0;
    width: 100%;
    justify-content: flex-start;
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    margin-bottom: 15px;
    padding-bottom: 10px;
  }
  
  .AudioSeries_categoryButton__g8HSX {
    flex-shrink: 0;
    font-size: 0.9rem;
    padding: 4px 12px;
  }
  
  .AudioSeries_navigationButtons__XgOPL {
    align-self: flex-end;
  }
  
  .AudioSeries_navButton__ae\\+KJ {
    width: 32px;
    height: 32px;
  }
  
  .AudioSeries_card__wX9fa img {
    height: 200px; /* Smaller image height for mobile */
  }
  
  .AudioSeries_cardContent__pFIup {
    padding: 12px;
  }
  
  .AudioSeries_cardTitle__dagGk {
    font-size: 0.85rem;
    line-height: 1.2;
    margin-bottom: 3px;
  }
  
  .AudioSeries_creatorName__6K57N {
    font-size: 0.75rem;
    margin: 2px 0;
  }
  
  .AudioSeries_episodeCount__80GE\\+ {
    font-size: 0.7rem;
  }
  
  .AudioSeries_listenButton__FoiyR {
    padding: 5px 10px;
    font-size: 0.7rem;
    margin-top: 5px;
  }
}

/* Very small devices */
@media (max-width: 480px) {
  .AudioSeries_container__pkWFU {
    width:100% ; 
    margin: 0 auto;
  }
  .AudioSeries_categories__Q3Iln{
    margin-bottom: 0px;
  }
  
  .AudioSeries_card__wX9fa img {
    height: 150px; /* Even smaller for very small screens */
  }
  
  .AudioSeries_cardContent__pFIup {
    padding: 8px;
  }
  
  .AudioSeries_cardTitle__dagGk {
    font-size: 0.75rem;
    max-height: 2.4em;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  
  .AudioSeries_creatorName__6K57N {
    font-size: 0.65rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .AudioSeries_listenButton__FoiyR {
    padding: 4px 8px;
    font-size: 0.65rem;
    margin-top: 4px;
  }
  
  .AudioSeries_episodeCount__80GE\\+ {
    font-size: 0.6rem;
  }
  
  .AudioSeries_navButton__ae\\+KJ {
    width: 28px;
    height: 28px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Homepage/components/Css/AudioSeries.module.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa,EAAE,oCAAoC;EACrD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa,EAAE,wCAAwC;EACzD;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Responsive container */\n.container {\n  color: white;\n  width: 100%;\n  max-width: 95%;\n  margin: 0 auto;\n}\n\n/* Responsive header section */\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  max-width: 100%;\n  margin: 0 auto;\n  flex-wrap: wrap;\n}\n\n.title {\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.categories {\n  display: flex;\n  gap: 15px;\n  margin: 0 20px;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  padding-bottom: 5px;\n}\n\n.swiperCard {\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.categoryButton {\n  padding: 5px 15px;\n  border: none;\n  background: transparent;\n  color: white;\n  cursor: pointer;\n  border-radius: 20px;\n  transition: all 0.3s ease;\n  font-weight: 600;\n}\n\n.categoryButton.active {\n  background: #ff0000;\n}\n\n.navigationButtons {\n  display: flex;\n  gap: 10px;\n}\n\n.navButton {\n  background: transparent;\n  border: 1px solid #ffffff40;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: white;\n}\n\n.navButton:hover {\n  background: #ffffff10;\n}\n\n.cardContainer {\n  position: relative;\n  cursor: pointer;\n}\n\n.card {\n  position: relative;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.card img {\n  width: 100%;\n  height: 250px;\n  display: block;\n  object-fit: cover;\n}\n\n.cardContent {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 20px;\n}\n\n.cardTitle {\n  font-weight: bold;\n  margin-bottom: 5px;\n  font-size: 1rem;\n}\n\n.creatorName {\n  font-size: 0.9rem;\n  margin: 4px 0;\n}\n\n.episodeCount {\n  font-size: 0.8rem;\n  opacity: 0.9;\n  margin: 5px 0;\n}\n\n.listenButton {\n  background: #ff0000;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 20px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-top: 10px;\n  font-size: 14px;\n}\n\n.noContentMessage {\n  color: #ffffff80;\n  text-align: center;\n  padding: 30px 0;\n}\n\n.loadingContainer {\n  color: #ffffff80;\n  text-align: center;\n  padding: 30px 0;\n}\n\n/* Mobile specific styles */\n@media (max-width: 768px) {\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .title {\n    margin-bottom: 15px;\n    width: 100%;\n    font-size: 18px;\n  }\n  \n  .categories {\n    margin: 0;\n    width: 100%;\n    justify-content: flex-start;\n    overflow-x: auto;\n    white-space: nowrap;\n    -webkit-overflow-scrolling: touch;\n    margin-bottom: 15px;\n    padding-bottom: 10px;\n  }\n  \n  .categoryButton {\n    flex-shrink: 0;\n    font-size: 0.9rem;\n    padding: 4px 12px;\n  }\n  \n  .navigationButtons {\n    align-self: flex-end;\n  }\n  \n  .navButton {\n    width: 32px;\n    height: 32px;\n  }\n  \n  .card img {\n    height: 200px; /* Smaller image height for mobile */\n  }\n  \n  .cardContent {\n    padding: 12px;\n  }\n  \n  .cardTitle {\n    font-size: 0.85rem;\n    line-height: 1.2;\n    margin-bottom: 3px;\n  }\n  \n  .creatorName {\n    font-size: 0.75rem;\n    margin: 2px 0;\n  }\n  \n  .episodeCount {\n    font-size: 0.7rem;\n  }\n  \n  .listenButton {\n    padding: 5px 10px;\n    font-size: 0.7rem;\n    margin-top: 5px;\n  }\n}\n\n/* Very small devices */\n@media (max-width: 480px) {\n  .container {\n    width:100% ; \n    margin: 0 auto;\n  }\n  .categories{\n    margin-bottom: 0px;\n  }\n  \n  .card img {\n    height: 150px; /* Even smaller for very small screens */\n  }\n  \n  .cardContent {\n    padding: 8px;\n  }\n  \n  .cardTitle {\n    font-size: 0.75rem;\n    max-height: 2.4em;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n  }\n  \n  .creatorName {\n    font-size: 0.65rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  .listenButton {\n    padding: 4px 8px;\n    font-size: 0.65rem;\n    margin-top: 4px;\n  }\n  \n  .episodeCount {\n    font-size: 0.6rem;\n  }\n  \n  .navButton {\n    width: 28px;\n    height: 28px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AudioSeries_container__pkWFU`,
	"header": `AudioSeries_header__ExAa7`,
	"title": `AudioSeries_title__uHQLU`,
	"categories": `AudioSeries_categories__Q3Iln`,
	"swiperCard": `AudioSeries_swiperCard__87HuK`,
	"categoryButton": `AudioSeries_categoryButton__g8HSX`,
	"active": `AudioSeries_active__AEBz3`,
	"navigationButtons": `AudioSeries_navigationButtons__XgOPL`,
	"navButton": `AudioSeries_navButton__ae+KJ`,
	"cardContainer": `AudioSeries_cardContainer__k032t`,
	"card": `AudioSeries_card__wX9fa`,
	"cardContent": `AudioSeries_cardContent__pFIup`,
	"cardTitle": `AudioSeries_cardTitle__dagGk`,
	"creatorName": `AudioSeries_creatorName__6K57N`,
	"episodeCount": `AudioSeries_episodeCount__80GE+`,
	"listenButton": `AudioSeries_listenButton__FoiyR`,
	"noContentMessage": `AudioSeries_noContentMessage__3Ftgh`,
	"loadingContainer": `AudioSeries_loadingContainer__RupVx`
};
export default ___CSS_LOADER_EXPORT___;
